import { ItemModel } from '@aytm/app/insights/dashboard/models/BlockModel'

const radix = 26

export const getLetter = (index: number, lower?: boolean) => {
  let rest = 0
  let rank = 0
  while (index >= rest + Math.pow(radix, rank + 1)) {
    rest += Math.pow(radix, ++rank)
  }
  let value = index - rest
  const codes = []
  while (rank >= 0) {
    const div = Math.pow(radix, rank--)
    const code = Math.floor(value / div)
    while (value >= div) value -= div
    codes.push(code)
  }
  return codes.map(v => (lower ? String.fromCharCode(65 + v).toLowerCase() : String.fromCharCode(65 + v))).join('')
}

export const forLetterStore = (letterStore: Record<string, string> = {}) => {
  const getSubjectLetter = <T extends { findItemLetter(uid: string): string; hasItemLetter(letter: string): boolean }>(
    uid: string,
    blockModel: T
  ) => {
    let letter = letterStore[uid] || blockModel?.findItemLetter(uid) || ''
    if (!letter) {
      let index = 0
      letter = getLetter(index)
      const values = Object.values(letterStore)
      const valuesSet = new window.Set(values)
      while (valuesSet.has(letter) || blockModel?.hasItemLetter(letter)) {
        letter = getLetter(++index)
      }
      letterStore[uid] = letter
    }
    return letter
  }

  const getItemLetterMapper =
    <T extends { findItemLetter(uid: string): string; hasItemLetter(letter: string): boolean }>(blockModel: T) =>
    (item: ItemModel): ItemModel => {
      if (item && !item.letter) {
        const letter = getSubjectLetter(item.uid, blockModel)
        return { ...item, letter }
      }
      return item
    }

  return { getItemLetterMapper, getSubjectLetter }
}
